import { render, staticRenderFns } from "./IconHyperlink.vue?vue&type=template&id=4a456c63"
import script from "./IconHyperlink.vue?vue&type=script&lang=js"
export * from "./IconHyperlink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports